module.exports = __webpack_public_path__ + "static/media/ladders-and-slides.9344f117.png";